import React, { useEffect, useContext } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import * as H from 'history'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { useEffectSkipFirst } from 'utils/hooks'
import { Button } from 'react-bootstrap'
import { A4 } from 'components/shared/print'
import { setPageSize, toDateText } from 'utils/util'
import styled from 'styled-components'
import { useFetchQcLedgerApi } from 'api/qc_ledger'

type Props = {
    history: H.History
}

const Th = styled.th`
    border: solid 1px black;
    padding: 5px;
    text-align: center;
`

const Td = styled.td`
    border: solid 1px black;
    padding: 0px 5px;
    text-align: center;
`

const DisposalLedgerPage = ({ history }: Props) => {
    const params = useParams<{ id?: string }>()
    const globalState = useContext(GlobalStateContext)
    const api = useFetchQcLedgerApi()

    useEffect(() => {
        api.execute(Number(params.id))
        setPageSize('portrait')
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    const qcLedger = () => {
        return api.response.qcLedger
    }
    return (
        <>
            <Flex className="no-print" alignItems="flex-end">
                <div>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            <A4 landscape={false} padding={0}>
                <div style={{ padding: '60px 105px' }}>
                    <Flex style={{ fontSize: 11 }} justifyContent="flex-end">
                        <div>
                            <div>Form06.01：統計学的精度管理台帳</div>
                            <div>Version1: 2021/10/20</div>
                        </div>
                    </Flex>
                    <div style={{ fontSize: 24, fontWeight: 'bold', margin: '40px 0 10px 0', textAlign: 'center' }}>統計学的精度管理台帳</div>
                    <div style={{ margin: '0 30px', fontSize: 15 }}>
                        <table>
                            <tr>
                                <td style={{ width: 30, verticalAlign: 'top' }}>1.</td>
                                <td>
                                    <div>精度管理標準作業書（RCL0601）に従い、Xbar-R管理図を作成、リスク評価結果の定性検査を行います。</div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: 30, verticalAlign: 'top' }}>2.</td>
                                <td>
                                    <div>管理者、及び精度管理責任者は、データベース上で確認し、月に1度、管理実施状況報告書(Form12.01)に押印する。</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div style={{ fontSize: 14, marginTop: 20 }}>
                        <table style={{ border: 'solid 2px black', width: '100%' }}>
                            <tbody>
                                <tr>
                                    <Td colSpan={4}>精度管理情報</Td>
                                </tr>
                                <tr>
                                    <Td style={{ width: 90 }}>報告日</Td>
                                    <Td style={{ width: 245 }}>{toDateText(qcLedger()?.createDate)}</Td>
                                    <Td style={{ width: 90 }}>報告者</Td>
                                    <Td>{qcLedger()?.user?.fullName}</Td>
                                </tr>
                                <tr>
                                    <Td>管理限界を外れた日</Td>
                                    <Td>
                                        {toDateText(qcLedger()?.end)} ~ {toDateText(qcLedger()?.end)}
                                    </Td>
                                    <Td>指導監督医への報告日</Td>
                                    <Td>{toDateText(qcLedger()?.reportingDate)}</Td>
                                </tr>
                                <tr>
                                    <Td colSpan={4}>原因</Td>
                                </tr>
                                <tr>
                                    <Td colSpan={4} style={{ height: 120, textAlign: 'left' }}>
                                        {qcLedger()?.cause}
                                    </Td>
                                </tr>
                                <tr>
                                    <Td colSpan={4}>対応措置</Td>
                                </tr>
                                <tr>
                                    <Td colSpan={4} style={{ height: 120, textAlign: 'left' }}>
                                        {qcLedger()?.action}
                                    </Td>
                                </tr>
                                <tr>
                                    <Td colSpan={4}>防止策</Td>
                                </tr>
                                <tr>
                                    <Td colSpan={4} style={{ height: 120, textAlign: 'left' }}>
                                        {qcLedger()?.measures}
                                    </Td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </A4>
        </>
    )
}

export default withRouter(DisposalLedgerPage)
